import { ProjectStatus, UserRole } from 'providence-types';

export const canUserEditByProjectStatusAndRoles = (
  projectStatus: ProjectStatus,
  roles?: UserRole[],
) =>
  projectStatus !== ProjectStatus.Hold ||
  roles?.includes(UserRole.Accounting) ||
  roles?.includes(UserRole.Admin);
